import type { Reaction } from "./card";
import type { Icon } from "./icon";
import type { AuthUser } from "./user";

export type StickyChangeKind =
  | "create"
  | "update"
  | "delete"
  | "mirror"
  | "unmirror"
  | "link"
  | "unlink";

export interface StickyChange {
  stickyId: string;
  timestamp: Date;
  user: AuthUser;
  kind: StickyChangeKind;
  fields: FieldChange[];
}

// Sticky properties that we can render in the Activity Panel,
// with mappings from their server-key to local-key
const stickyProperties = {
  text: "text",
  status: "status",
  type_id: "type",
  story_points: "points",
  WSJF_value: "priority",
  step_value: "priority",
  risk: "risk",
  iteration_number: "iterationId",
  team_id: "teamId",
  reactions: "reactions",
  flag_type: "flagType",
  depend_team_id: "dependTeamId",
  assignee: "assignee",
  reporter: "reporter",
  alm_issue_id: "almId",
} as const;

// Other changes that we can render in the Activity Panel
const otherStickyChanges = {
  mirror: "mirrorBoard",
  link: "link",
  create: "create",
  delete: "delete",
} as const;

export const stickyActivityKeys = { ...stickyProperties, ...otherStickyChanges } as const;

export type FieldChangeName = (typeof stickyActivityKeys)[keyof typeof stickyActivityKeys];

// Reverse mapping (local-key to server-key)
export const serverStickyActivityKeys: Record<FieldChangeName, string> = Object.fromEntries(
  Object.entries(stickyActivityKeys).map(([key, value]) => [value, key]),
) as Record<FieldChangeName, string>;

export interface FieldChange<T = unknown> {
  name: FieldChangeName;
  old?: T;
  new?: T;
}

export type ReactionField = Record<Reaction, number>;

export interface ChangeTypeItem {
  id: FieldChangeName;
  name: string;
  icon: Icon;
}
